import React from 'react'
import { Route } from 'react-router-dom'
import { withProtectedPortalRoute } from './withProtectedPortalRoute'

const ProtectedPortalRoute = props => (
  <Route
    {...props}
    component={withProtectedPortalRoute({
      onFetchPortalError: props.onFetchPortalError,
    })(props.component)}
  />
)

export default ProtectedPortalRoute



// WEBPACK FOOTER //
// ./src/modules/portal/ProtectedPortalRoute.js